import clsx from 'clsx';
import React, { ReactElement } from 'react';
import NextImage from 'next/image';
import {
  makeElementClassNameFactory,
  makeRootClassName,
  StyleProps,
} from '@/utils';
import { Text } from '@/components';

export type PartnersProps = StyleProps & {
  // add props here
};

const SOLANA_LOGO = '/images/partners/solana.svg';
const SOLANA_HEIGHT = 18;
const SOLANA_WIDTH = 145;

const OPEN_SEA_LOGO = '/images/partners/opensea.svg';
const OPEN_SEA_HEIGHT = 40;
const OPEN_SEA_WIDTH = 147;

const BINANCE_LOGO = '/images/backed-by/binance.svg';
const BINANCE_HEIGHT = 29;
const BINANCE_WIDTH = 185;

const AAVE_LOGO = '/images/partners/aave.svg';
const AAVE_HEIGHT = 22;
const AAVE_WIDTH = 83;

const CIRCLE_LOGO = '/images/partners/circle.svg';
const CIRCLE_HEIGHT = 34;
const CIRCLE_WIDTH = 134;

const CIVIC_LOGO = '/images/partners/civic.svg';
const CIVIC_HEIGHT = 39;
const CIVIC_WIDTH = 112;

const HEDERA_LOGO = '/images/partners/hedera.svg';
const HEDERA_HEIGHT = 45;
const HEDERA_WIDTH = 147;

const RANSOMWHERE_LOGO = '/images/partners/ransomwhere.svg';
const RANSOMWHERE_HEIGHT = 35;
const RANSOMWHERE_WIDTH = 202;

const INCH_LOGO = '/images/partners/1inch.svg';
const INCH_HEIGHT = 63;
const INCH_WIDTH = 67;

const LEDGER_LOGO = '/images/partners/ledger.svg';
const LEDGER_HEIGHT = 41;
const LEDGER_WIDTH = 123;

const METAMASK_LOGO = '/images/partners/metamask.svg';
const METAMASK_HEIGHT = 45;
const METAMASK_WIDTH = 51;

const SAFEPAL_LOGO = '/images/partners/safepal.svg';
const SAFEPAL_HEIGHT = 50;
const SAFEPAL_WIDTH = 140;

const AVASCAN_LOGO = '/images/partners/avascan.svg';
const AVASCAN_HEIGHT = 42;
const AVASCAN_WIDTH = 77;

const WEBACY_LOGO = '/images/partners/webacy.svg';
const WEBACY_HEIGHT = 29;
const WEBACY_WIDTH = 109;

const BLOKK_LOGO = '/images/partners/blokk.svg';
const BLOKK_HEIGHT = 24;
const BLOKK_WIDTH = 101;

const BEACONCHA_LOGO = '/images/partners/beaconcha.svg';
const BEACONCHA_HEIGHT = 40;
const BEACONCHA_WIDTH = 53;

const ROOT = makeRootClassName('Partners');
const el = makeElementClassNameFactory(ROOT);

const DEFAULT_PROPS = {} as const;

function Partners(props: PartnersProps): ReactElement {
  const p = { ...DEFAULT_PROPS, ...props };

  return (
    <div className={clsx(ROOT, p.className)}>
      <div className={el`box`}>
        <Text type="h4" className={el`title`}>
          Chainabuse Partners
        </Text>
        <div className={el`logos-1`}>
          <NextImage
            src={SOLANA_LOGO}
            width={SOLANA_WIDTH}
            height={SOLANA_HEIGHT}
            alt="Solana logo"
            className={el`image`}
          />
          <NextImage
            src={OPEN_SEA_LOGO}
            width={OPEN_SEA_WIDTH}
            height={OPEN_SEA_HEIGHT}
            alt="Open sea logo"
            className={el`image`}
          />
          <NextImage
            src={BINANCE_LOGO}
            width={BINANCE_WIDTH}
            height={BINANCE_HEIGHT}
            alt="Binance logo"
            className={el`image`}
          />
          <NextImage
            src={AAVE_LOGO}
            width={AAVE_WIDTH}
            height={AAVE_HEIGHT}
            alt="AAVE logo"
            className={el`image`}
          />
          <NextImage
            src={CIRCLE_LOGO}
            width={CIRCLE_WIDTH}
            height={CIRCLE_HEIGHT}
            alt="Circle logo"
            className={el`image`}
          />
          <NextImage
            src={CIVIC_LOGO}
            width={CIVIC_WIDTH}
            height={CIVIC_HEIGHT}
            alt="Civic logo"
            className={el`image`}
          />
          <NextImage
            src={HEDERA_LOGO}
            width={HEDERA_WIDTH}
            height={HEDERA_HEIGHT}
            alt="Hedera logo"
            className={el`image`}
          />
          <NextImage
            src={RANSOMWHERE_LOGO}
            width={RANSOMWHERE_WIDTH}
            height={RANSOMWHERE_HEIGHT}
            alt="Ransomwhere logo"
            className={el`image`}
          />
        </div>
        <div className={el`logos-2`}>
          <NextImage
            src={INCH_LOGO}
            width={INCH_WIDTH}
            height={INCH_HEIGHT}
            alt="1inch logo"
            className={el`image`}
          />
          <NextImage
            src={LEDGER_LOGO}
            width={LEDGER_WIDTH}
            height={LEDGER_HEIGHT}
            alt="Ledger logo"
            className={el`image`}
          />
          {/* <NextImage
            src={METAMASK_LOGO}
            width={METAMASK_WIDTH}
            height={METAMASK_HEIGHT}
            alt="Metamask logo"
            className={el`image`}
          /> */}
          <NextImage
            src={SAFEPAL_LOGO}
            width={SAFEPAL_WIDTH}
            height={SAFEPAL_HEIGHT}
            alt="Safepal logo"
            className={el`image`}
          />
        </div>
        {/* @TODO: 
          we are waiting for metamask permission
          to show their logo on chainabuse. Once we have it:
          move the 4 <NextImage /> of .logos-3 to .logos-2
          AND
          uncomment the metamask icon above
        */}
        <div className={el`logos-3`}>
          <NextImage
            src={AVASCAN_LOGO}
            width={AVASCAN_WIDTH}
            height={AVASCAN_HEIGHT}
            alt="Avascan logo"
            className={el`image`}
          />
          <NextImage
            src={WEBACY_LOGO}
            width={WEBACY_WIDTH}
            height={WEBACY_HEIGHT}
            alt="Webacy logo"
            className={el`image`}
          />
          <NextImage
            src={BLOKK_LOGO}
            width={BLOKK_WIDTH}
            height={BLOKK_HEIGHT}
            alt="BLOKK logo"
            className={el`image`}
          />
          <NextImage
            src={BEACONCHA_LOGO}
            width={BEACONCHA_WIDTH}
            height={BEACONCHA_HEIGHT}
            alt="Beaconcha.in logo"
            className={el`image`}
          />
        </div>
      </div>
    </div>
  );
}

export default Partners;
